import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FishingLicenceInformation.module.scss'
import { commercialAquacultureAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const CommercialAquaculture = ({ t, validateCommercialAquaculture, commercialAquacultureError, commercialAquacultureValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const commercialAquaculture = useSelector((state) => state.app.commercialAquaculture)

  const handleCommercialAquaculture = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(commercialAquacultureAction(name))
      validateCommercialAquaculture(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurCommercialAquaculture = (e) => {
    try {
      let name = e.currentTarget.value.trim()
      SetIsFocussed(false)
      dispatch(commercialAquacultureAction(name))
      validateCommercialAquaculture(commercialAquaculture)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        commercialAquacultureValid === true ? (commercialAquaculture === '' ? '' : 'form-group has-success') : commercialAquacultureValid === false ? 'form-group has-error ns-form-group-message-error' : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="CommercialAquaculture">
        {t('fishing_licence_info.commercial_aquaculture')}
      </label>
      {commercialAquacultureValid === false && (
        <div className="ns-form-error-container">
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(commercialAquacultureError)}</div>
        </div>

      )}
      <input
        type="text"
        id="CommercialAquaculture"
        className="form-control"
        value={commercialAquaculture}
        onChange={handleCommercialAquaculture}
        onBlur={onBlurCommercialAquaculture}
        onFocus={() => SetIsFocussed(true)}
        autoComplete="off"
        maxLength="7"
      />
      {commercialAquacultureValid === true && commercialAquaculture !== '' && (
        <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
      )}
    </div>
  )
}

export default withTranslation('common')(CommercialAquaculture)
